// extracted by mini-css-extract-plugin
export default {"root":"EntityList_root__VIYOQ","container":"EntityList_container__2EeR+"};